<template>
  <div id="texto-classificacao-indicador">
    <loader :value="classificacao" :loading="loading"></loader>
    <span
      v-if="!loading"
      v-b-tooltip.html.hover
      :title="getTextoClassificacaoPorIndicador(idIndicador, classificacao)"
      class="icon-tooltip"
    >
      <i class="icofont-info-circle"></i>
    </span>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import utils from '@/mixins/utils'

export default {
  props: {
    enabledLoader: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    idIndicador: {
      type: [String, Number],
      default: '',
    },
    classificacao: {
      type: String,
      default: '',
    },
    resultado: {
      type: [String, Number],
      default: '',
    },
  },
  components: {
    Loader,
  },
  mixins: [utils],
  methods: {
    /**
     * Retorna o texto explicativo da classificação de um indicador,
     * contendo o peso, a pontuação, os parâmetros utilizados, a
     * classificação e a nota correspondente.
     *
     * @param {String|Number} idIndicador Identificador do indicador.
     * @param {String} classificacao Classificação do indicador.
     * @returns {String|null} Texto formatado para o tooltip ou `null` quando não houver regra cadastrada.
     */
    getTextoClassificacaoPorIndicador(idIndicador, classificacao) {
      const lista = this.$store.state.regrasIndicadoresAps || []

      const classificacaoNormalizada = String(classificacao || '').toUpperCase()

      // Se for Regular, pode ter vários registros
      const itens =
        classificacaoNormalizada === 'REGULAR'
          ? lista.filter(
              (i) =>
                i.id_indicador == idIndicador &&
                String(i.classificacao || '').toUpperCase() ===
                  classificacaoNormalizada
            )
          : [
              lista.find(
                (i) =>
                  i.id_indicador == idIndicador &&
                  String(i.classificacao || '').toUpperCase() ===
                    classificacaoNormalizada
              ),
            ].filter(Boolean)

      if (!itens.length) return null

      const partesParametro = itens
        .map((item) => {
          const partes = []

          if (item.sinal_min && item.min_val) {
            partes.push(`${item.sinal_min} ${item.min_val}`)
          }

          if (item.sinal_max && item.max_val) {
            partes.push(`${item.sinal_max} ${item.max_val}`)
          }

          // Se vierem os dois no mesmo registro, junta com " e "
          return partes.join(' e ')
        })
        .filter(Boolean)

      const parametro = partesParametro.join(' e ')

      const ref = itens[0]

      return `Peso: ${ref.peso} <br> Pontuação: ${this.resultado} ${parametro} <br> Classificação: ${ref.classificacao} (${ref.val_classificacao}) <br> Nota: ${ref.nota} (Peso * Classificação)`
    },
  },
}
</script>

<style lang="scss" scoped>
#texto-classificacao-indicador {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  span {
    color: #000 !important;
  }
}
</style>
